export enum OperationTimeStatusEnum {
    OPERATION_STATUS_NOT_STARTED = 'OPERATION_NOT_STARTED',
    OPERATION_STATUS_IN_PROGRESS = 'OPERATION_IN_PROGRESS',
    OPERATION_STATUS_FINISHED = 'OPERATION_FINISHED',
    OPERATION_STATUS_STARTED_LATE = 'OPERATION_STARTED_LATE',
    OPERATION_STATUS_FINISHED_LATE = 'OPERATION_FINISHED_LATE',
    OPERATION_STATUS_CANCELLED = 'OPERATION_CANCELLED',
    OPERATION_STATUS_EMERGENCY = 'OPERATION_EMERGENCY',
}
